import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "../../services/http.service";
import { ToolsService } from "../../services/tools.service";
import { MouvementDialogComponent } from "./mouvement-dialog";
import { ToastrService } from "../../components/_toastr/toastr.service";
import { Mouvement } from "../../interfaces/Mouvement";

@Injectable({
  providedIn: "root",
})
export class MouvementDialogService {
  constructor(
    private _dialog: MatDialog,
    private _http: HttpService,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  openDialog(
    mouvement_ID: number,
    actionnaire_ID: number = 0,
    callBack: Function = () => {}
  ): void {
    const dialogRef = this._dialog.open(MouvementDialogComponent, {
      width: "900px",
      data: { mouvement_ID, actionnaire_ID },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  openDeleteDialog(
    mouvement_ID: number,
    actionnaire_ID: number = 0,
    callBack: Function = () => {}
  ): void {
    const dialogRef = this._dialog.open(MouvementDialogComponent, {
      width: "900px",
      data: { mouvement_ID, actionnaire_ID, deleteMode: true },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  get(mouvement_ID: number, callBack: Function): void {
    this._http.GET(
      "/api/mouvement/" + mouvement_ID,
      null,
      (result) => {
        if (result.isOk) {
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  post(mouvement: Mouvement, callBack: Function): void {
    this._http.POST(
      "/api/mouvement",
      mouvement,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Mouvement enregistré avec succès",
            type: "success",
          });
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  preview(mouvement: Mouvement, callBack: Function): void {
    this._http.POST(
      "/api/mouvement/preview",
      mouvement,
      (result) => {
        if (result.isOk && result.obj) {
          callBack(result.obj);
        } else {
          // Si erreur backend, créer un preview invalide
          const errorPreview = {
            IsValid: false,
            ErrorMessage:
              result.message ||
              "Une erreur est survenue lors de la prévisualisation",
            Actionnaire1: null,
            Actionnaire2: null,
            Societe: null,
          };
          callBack(errorPreview);
        }
      },
      (error) => {
        this._tools.showHttpError(error);
        // En cas d'erreur HTTP, créer un preview invalide
        const errorPreview = {
          IsValid: false,
          ErrorMessage: "Erreur de connexion au serveur",
          Actionnaire1: null,
          Actionnaire2: null,
          Societe: null,
        };
        callBack(errorPreview);
      }
    );
  }

  deletePreview(mouvement_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/mouvement/preview/" + mouvement_ID,
      null,
      (result) => {
        if (result.isOk && result.obj) {
          callBack(result.obj);
        } else {
          // Si erreur backend, créer un preview invalide
          const errorPreview = {
            isValid: false,
            errorMessage:
              result.message ||
              "Une erreur est survenue lors de la prévisualisation de suppression",
            actionnaire1: null,
            actionnaire2: null,
            societe: null,
          };
          callBack(errorPreview);
        }
      },
      (error) => {
        this._tools.showHttpError(error);
        // En cas d'erreur HTTP, créer un preview invalide
        const errorPreview = {
          isValid: false,
          errorMessage: "Erreur de connexion au serveur",
          actionnaire1: null,
          actionnaire2: null,
          societe: null,
        };
        callBack(errorPreview);
      }
    );
  }

  delete(mouvement_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/mouvement/" + mouvement_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Mouvement supprimé avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  actionner(mouvement_ID: number, callBack: Function): void {
    this._http.POST(
      "/api/mouvement/actionner/" + mouvement_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Mouvement actionné avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
